/* eslint-disable react-hooks/exhaustive-deps */
import Paper from "@material-ui/core/Paper";
import Dissatisfied from "@material-ui/icons/SentimentVeryDissatisfied";
import FilterContainer from "components/containers/FilterContainer";
import InputFilter from "components/inputs/InputFilter";
import { useStyles } from "components/layout/CommonStyles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { screenStyles } from "pages/libraryModule/MyLoans/Styles";
import DialogLibraryLoan from "pages/libraryModule/dialogs/LibraryLoans/DialogLibraryLoan";
import { AllAuthorsName } from "utils/library/AllAuthorsName";
import InputFilterDate from "components/inputs/InputFilterDate";
import { dateToBR } from "utils/dates/DateToBRr";
import { FormatDateToFront } from "utils/dates/FormatDateToFront";
import { translateStatus } from "utils/library/translateStatus";
import { LibraryReservationStatusValues } from "global/constants";
import BookCardLibraryLoans from "pages/libraryModule/cards/BookCardLibraryLoans";
import { Link as LinkRouter } from "react-router-dom";
import { QueryGetValue } from "utils/general/QueryString";
import { formatImagePath } from "utils/library/formatImagePath";
import { nameSearchFilter } from "utils/filter/filterFields";

const LibraryLoansForm = props => {
  const { BooksLoanData, SubmitRequisition } = props;

  const [t] = useTranslation();
  const styles = screenStyles();
  const classes = useStyles();

  const [dialogData, setDialogData] = useState({});

  const [filterTitle, setFilterTitle] = useState("");
  const [filterAuthor, setFilterAuthor] = useState("");
  const [filterCollaborator, setFilterCollaborator] = useState("");
  const [filterDate, setFilterDate] = useState(null);
  const [filterStatusType, setFilterStatusType] = useState("");

  const [findText, setFindText] = useState("");
  const [dataFilter, setDataFilter] = useState([]);
  const hasItens = BooksLoanData.length > 0;
  const [hasNoResult, setHasNoResult] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [originalFine, setOriginalFine] = useState("");

  const statusTypes = [
    { label: "Todos", value: "Todos" },
    {
      label: translateStatus(LibraryReservationStatusValues.LOAN),
      value: LibraryReservationStatusValues.LOAN,
    },
    {
      label: translateStatus(LibraryReservationStatusValues.LATE),
      value: LibraryReservationStatusValues.LATE,
    },
  ];

  const handleOpenDialog = index => {
    const reservation = dataFilter[index];
    setOriginalFine(reservation.fine);
    setDialogData(reservation);
    setOpenDialog(true);
  };

  const applyFilter = filterArray => {
    let newDataFilter = [];
    let textNoFound = "";

    newDataFilter = filterArray;

    if (filterTitle) {
      newDataFilter = newDataFilter.filter(item =>
        nameSearchFilter(item.book.title, filterTitle)
      );

      if (!textNoFound && newDataFilter.length === 0) textNoFound = filterTitle;
    }

    if (filterAuthor) {
      newDataFilter = newDataFilter.filter(item =>
        nameSearchFilter(AllAuthorsName(item.book.authors), filterAuthor)
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = filterAuthor;
    }

    if (filterCollaborator) {
      newDataFilter = newDataFilter.filter(item =>
        nameSearchFilter(item.user.shortname, filterCollaborator)
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = filterCollaborator;
    }

    if (filterDate && !isNaN(filterDate)) {
      let filterDateBR = dateToBR(filterDate);
      newDataFilter = newDataFilter.filter(
        item =>
          item.returnDate &&
          dateToBR(FormatDateToFront(item.returnDate)) === filterDateBR
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = filterDateBR;
    }

    if (
      filterStatusType &&
      filterStatusType.toLowerCase() !== t("GENERAL.allMasculine").toLowerCase()
    ) {
      newDataFilter = newDataFilter.filter(
        item => item.status === filterStatusType
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = translateStatus(filterStatusType);
    }

    return { newDataFilter, textNoFound };
  };

  useEffect(() => {
    if (BooksLoanData && BooksLoanData.length) {
      const { newDataFilter, textNoFound } = applyFilter(BooksLoanData);

      if (newDataFilter.length === 0) {
        setDataFilter([]);
        setHasNoResult(true);
        setFindText(textNoFound);
      } else {
        setDataFilter(newDataFilter);
        setHasNoResult(false);
        setFindText("");
      }
    }
  }, [
    BooksLoanData,
    filterTitle,
    filterAuthor,
    filterDate,
    filterCollaborator,
    filterStatusType,
  ]);

  useEffect(() => {
    if (QueryGetValue("panel") === "BOOKSLOAN") {
      setFilterTitle(QueryGetValue("title") || "");
      setFilterCollaborator(QueryGetValue("colaborator") || "");
      setFilterDate(
        QueryGetValue("devolutionDate")
          ? new Date(QueryGetValue("devolutionDate"))
          : null
      );
    }
  }, []);

  return (
    <React.Fragment>
      <FilterContainer>
        <InputFilter
          filterValue={filterTitle}
          setFilter={setFilterTitle}
          label={"INVENTORY.title"}
          maxLength={70}
        />
        <InputFilter
          filterValue={filterAuthor}
          setFilter={setFilterAuthor}
          label={"INVENTORY.BookAuthor"}
          maxLength={70}
        />
        <InputFilter
          filterValue={filterCollaborator}
          setFilter={setFilterCollaborator}
          label={"HR.collaborator"}
          maxLength={70}
        />
        <InputFilterDate
          filterValue={filterDate}
          setFilter={setFilterDate}
          label={"LIBRARY.dateDevolution"}
        />
        <InputFilter
          filterValue={filterStatusType}
          setFilter={setFilterStatusType}
          label={"GENERAL.status"}
          isSelect
          arraySelected={statusTypes}
        />
      </FilterContainer>

      <Paper style={{ maxHeight: 700, overflow: "auto" }}>
        <div className={styles.bookList}>
          {dataFilter.map((data, index) => {
            return (
              <BookCardLibraryLoans
                image={formatImagePath(
                  data.book.imagePath,
                  data.book.isImageUrl
                )}
                title={data.book.title}
                author={AllAuthorsName(data.book.authors)}
                colaboratorName={data.user.shortname}
                exemplarCode={data.exemplar.code}
                status={data.status}
                returnDate={dateToBR(FormatDateToFront(data.returnDate))}
                library={data.library}
                renovationCount={data.renovationCount}
                onClick={() => {
                  handleOpenDialog(index);
                }}
              />
            );
          })}
        </div>
        {!hasItens && (
          <div className={classes.noParticipantsMessage}>
            <h2>{t("LIBRARY.noMyBooksLoanMessage")}</h2>
            <p style={{ fontWeight: "400" }}>
              Para solicitar um empréstimo visite a página de{" "}
              <LinkRouter className={styles.Link} to="/BooksCollection">
                Acervo
              </LinkRouter>{" "}
              e escolha um livro.
            </p>
          </div>
        )}
        {dataFilter.length === 0 && findText && (
          <div className={classes.noParticipantsMessage}>
            <div>
              <Dissatisfied className={classes.notFoundIconStyle} />
            </div>
            <h2>{t("GENERAL.noResultsFound")}</h2>
            <h5>{`Sua busca por "${findText}" não retornou resultados.`}</h5>
          </div>
        )}
      </Paper>
      {openDialog && (
        <DialogLibraryLoan
          open={openDialog}
          setOpen={setOpenDialog}
          viewValues={dialogData}
          originalFine={originalFine}
          submit={SubmitRequisition}
        />
      )}
    </React.Fragment>
  );
};

export default LibraryLoansForm;
